import React from "react";
import { Link } from "react-router-dom";
import { BsChevronRight, BsPlus, BsCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

const InvoicesTable = () => {
  const navigate = useNavigate()

  const handleAddInvoice =()=>{
    navigate('/invoices/create')
  }
  const handleViewInvoice =()=>{
    navigate('/invoices/edit/86687')
  }
  const data = [
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
  ];

  return (
    <>
        {data.map((item, index) => (
          <>
            <div className="bg-gray-100 rounded-lg p-4 my-2">
              <Link onClick={handleViewInvoice} className="flex items-center justify-between ">
                <div className="flex items-center">
                  <BsCircleFill className="items-center text-red-600" size={15} />
                  <div className="ml-4">
                    <p className="text-gray-500 font-bold">
                      Invoice: 698798798
                    </p>
                    <div className="flex gap-2">
                      <p className="text-gray-500">07/05/2024</p>
                      <p className="text-red-400">Unpaid</p>
                    </div>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="px-2">2.00</span>
                  {/* <span>status</span> */}
                  <Button color="link" className="text-teal-500 p-0">
                    <BsChevronRight size={24} />
                  </Button>
                </div>
              </Link>
            </div>
          </>
        ))}

      {/* <span>Create a new invoice for this case</span> */}
      <div className="flex justify-center mt-3">
        <Button
          color="primary"
          onClick={handleAddInvoice}
          className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
        >
          <BsPlus size={20} className="mr-2" />
          Create Invoice
        </Button>
      </div>
    </>
  );
};

export default InvoicesTable;
